// extracted by mini-css-extract-plugin
module.exports = {"writeReview":"WriteReview_writeReview__82aGp","writeReviewForm":"WriteReview_writeReviewForm__FPoBP","signInWarning":"WriteReview_signInWarning__9_CxA"};